module.exports = __webpack_public_path__ + "static/img/game-logo-drogan.631cfe6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-drogan.png
// module id = EOmA
// module chunks = 0 1 2 3 4 5 6